import { CzechSuklRsAtcGroupResponse } from 'com.cogvio.pricemonitor.api';

export type GroupProductEntry = {
	product: CzechSuklRsAtcGroupResponse['products'][number];
	productIndex: number;
	versions: CzechSuklRsAtcGroupResponse['products'][number]['productVersions'];
};

/**
 * Iterates products within an ATC/RS group with their version lists, in API order.
 *
 * @param {CzechSuklRsAtcGroupResponse} group the group to iterate.
 * @returns {GroupProductEntry[]} products with their version lists.
 */
export function iterateGroupProducts(group: CzechSuklRsAtcGroupResponse): GroupProductEntry[] {
	return group.products.map((product, productIndex) => ({
		product,
		productIndex,
		versions: product.productVersions,
	}));
}
